const {
  StylableWebpackPlugin,
  applyWebpackConfigStylableExcludes,
} = require('@stylable/webpack-plugin');

const StylableOptimizer = require('@stylable/optimizer').StylableOptimizer;

const stylableOptimizer = new StylableOptimizer();
const packages = new Set(['wix-style-react']);

export const decorateNextJsWebpackConfig = (
  config: any,
  { isServer }: { isServer: boolean },
) => {
  // causes provided packages to be bundled (not external)
  if (isServer) {
    const nextExternals = config.externals[0];
    config.externals = [
      async (ctx: any) => {
        // @ts-ignore
        for (const pack of packages) {
          if (ctx.request.startsWith(pack)) {
            return false;
          }
        }
        return nextExternals(ctx);
      },
    ];
  }

  // excludes other configs from attempting to handle stylable files
  applyWebpackConfigStylableExcludes(config);

  config.plugins.push(
    new StylableWebpackPlugin({
      filterAssets: () => false,
      filename: 'static/css/stylable.[contenthash].css',
      optimizer: stylableOptimizer,
    }),
  );

  return config;
};
